import { FieldError } from "react-hook-form";

export const ConditionalFieldError = (props: { error?: FieldError }) => {
	return (
		<span>
			{props.error ? props.error.message : ''}
		</span>
	);
};